import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import { formatTime } from 'component/util'
import ModuleItem from '../../../../imageDetail/infoView/info/detail/moduleItem'
import MultiItem from '../../../../imageDetail/infoView/info/detail/multiItem'
import styles from './index.module.less'

export default ({ currentImage, onPropIndex, onVisibleChange, }) => {
  const {
    designerNameList = [],
    designerAssistantNameList = [],
    typesetter,
    sampleMaker,
    createName,
    updateName,
    createdAt,
    updatedAt
  } = currentImage
  return <div className={classNames(styles.infoBlock, 'mt32')}>
    <div className={styles.titleLine}>
      <div className={styles.point} />
      <div className={styles.mainTitle}>相关人员</div>
      <a
        className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
        onClick={() => {
          onPropIndex(0)
          onVisibleChange(true)
        }}
      >
        <Icon type="m-bianji" style={{ marginRight: 2, fontSize: '16px' }} />编辑
      </a>
    </div>
    <div className={styles.infoBlockContext} style={{ marginTop: '6px' }}>
      <MultiItem label="设计师" values={designerNameList} mb12={false} style={{ marginBottom: '12px' }} />
      <MultiItem label="设计师助理" values={designerAssistantNameList} mb12={false} style={{ marginBottom: '12px' }} />
      <ModuleItem label="打版师" value={typesetter} />
      <ModuleItem label="样衣工" value={sampleMaker} />
      <ModuleItem label="创建时间" value={<><span className={classNames(styles['module-span-name'], 'text-overflow')}>{createName}</span><span className={styles['module-span-time']}>{formatTime(createdAt)}</span></>} />
      <ModuleItem label="更新时间" value={<><span className={classNames(styles['module-span-name'], 'text-overflow')}>{updateName}</span><span className={styles['module-span-time']}>{formatTime(updatedAt)}</span></>} />
    </div>
  </div>
}
